import { render, staticRenderFns } from "./AccidentIntakeSymptomDetailsForm.vue?vue&type=template&id=ae32530c&scoped=true"
import script from "./AccidentIntakeSymptomDetailsForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeSymptomDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeSymptomDetailsForm.vue?vue&type=style&index=0&id=ae32530c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae32530c",
  null
  
)

export default component.exports